import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rental-responsibility',
  templateUrl: './rental-responsibility.component.html',
  styleUrls: ['./rental-responsibility.component.scss']
})
export class RentalResponsibilityComponent implements OnInit {
  ngOnInit(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
